import { useEffect, useState } from "react";
import { Dropdown, Option, useId } from "@fluentui/react-components";
import { dropdownDataStyle } from "../../styles/customStyles";

export const DropdownComponent = (props: any) => {
  const { defaultSelected, placeholder, required, disabled, defaultValue } = props || {}
  const { setDropDownValue, optionData } = props;

  const [selectedVal, setSelectedVal] = useState(defaultSelected ? defaultSelected : '');

  useEffect(() => {
    setSelectedVal(defaultSelected || '');
  }, [defaultSelected]);

  const handleDropdown = (e: any) => {
    const checks = e.currentTarget.innerText;
    setSelectedVal(checks);
    setDropDownValue(checks); // props?.setDropDownValue(checks);
  };

  const dropdownData = () => optionData?.map(({ key, label }) =>
    <div style={dropdownDataStyle}>
      <Option key={key} value={key}>
        {label}
      </Option>
    </div>
  );

  return (
    <Dropdown
      size="small"
      value={selectedVal}
      aria-required={!!required}
      disabled={disabled ?? false}
      onOptionSelect={handleDropdown}
      defaultValue={defaultValue ?? null}
      placeholder={placeholder ?? "Select"}
      aria-labelledby={useId("dropdown-default")}
      defaultSelectedOptions={defaultValue ? [defaultValue] : []}
    >
      {dropdownData()}
    </Dropdown>
  );
};
